module.exports = __webpack_public_path__ + "img/play.a0038746.svg";